import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';

const subscriptionsSearchSchema = z.object({
  tab: z.literal(0).or(z.literal(1)).default(0),
  page: z.number().optional(),
});

export const Route = createFileRoute(
  '/_auth/_layout_with_full_navigation/subscriptions',
)({
  validateSearch: zodValidator(subscriptionsSearchSchema),
});
